import Bugsnag from "@bugsnag/js";
import { multiOrderOrchestrator as serverResponse } from "@nju/data-access-portal-orchestrator";
import { client } from "@nju/http-client";

export async function tryAgainMigratingMsisdn(orchestratorId: string) {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/TRY_AGAIN`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
